<template>
	<div style="background: #f5f5f5; min-height: 100vh">
		<brieHeader />
		<div class="logPage">
			<div class="logLeft">
				<img src="@/assets/mnjk/mnjk_login.jpg" alt="" v-if="tabFlag == 2" />
				<img src="@/assets/img/syImg.png" alt="" v=-else />
			</div>
			<div class="logRig">
				<div class="logBox">
					<div class="logTip" v-show="loginStatus == 0 || loginStatus == 1">
						<div class="logTipTit">
							{{ loginStatus == 1 ? '验证码登录' : '密码登录' }}
						</div>
						<p>
							没有账号？
							<span @click="zcFn" class="supHove3">点击注册</span>
						</p>
					</div>
					<div class="logTip logTipwj" v-show="loginStatus == 3 || loginStatus == 2">
						<div class="logTipTit">{{ loginStatus == 3 ? '忘记密码' : '二维码登录' }}</div>
					</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demoRuleForm">
						<el-form-item prop="phone" v-if="loginStatus != 2">
							<el-input v-model.number="ruleForm.phone" placeholder="请输入手机号" maxlength="11">
								<i slot="prefix" style="display: flex; align-items: center; height: 38px">
									<img class="header-icon" src="@/assets/img/sjh.png" alt="" />
								</i>
							</el-input>
						</el-form-item>
						<el-form-item prop="pasw" v-if="loginStatus == 0">
							<el-input v-model="ruleForm.pasw" placeholder="输入密码" show-password>
								<i slot="prefix" style="display: flex; align-items: center; height: 38px">
									<img class="header-icon" src="@/assets/img/mima.svg" alt="" />
								</i>
							</el-input>
						</el-form-item>
						<div class="logTx" v-if="loginStatus == 0 || loginStatus == 1 || loginStatus == 3">
							<el-form-item prop="code">
								<el-input v-model="ruleForm.code" placeholder="输入图形验证码">
									<i slot="prefix" style="display: flex; align-items: center; height: 38px">
										<img class="header-icon" src="@/assets/img/yzm.png" alt="" />
									</i>
								</el-input>
							</el-form-item>
							<button @click="init" class="twBtn btnS" v-preventReclick>
								<div>
									<img :src="yzImg" alt="" />
								</div>
							</button>
						</div>
						<el-form-item prop="smsCode" v-if="loginStatus == 1 || loginStatus == 3">
							<el-input v-model="ruleForm.smsCode" placeholder="输入短信验证码" :maxlength="6">
								<i slot="prefix" style="display: flex; align-items: center; height: 40px">
									<img src="@/assets/img/yanzhengma.png" alt="" />
								</i>
								<i slot="suffix">
									<div class="yymBox">
										<span class="hqyym supHove3" v-show="yymStatus == 0" @click="hqBtn">获取验证码</span>
										<div class="hqTime">
											<p v-show="yymStatus == 1">
												<span style="margin-right: 4px">{{ nums }}s</span>
												后重新发送
											</p>
											<span v-show="yymStatus == 2" class="hqyym supHove3" @click="hqBtn">重新获取验证码</span>
										</div>
									</div>
								</i>
							</el-input>
						</el-form-item>
						<el-form-item prop="password" v-if="loginStatus == 3">
							<el-input v-model="ruleForm.password" placeholder="请输入新密码" show-password>
								<i slot="prefix" style="display: flex; align-items: center; height: 38px">
									<img class="header-icon" src="@/assets/img/mima.svg" alt="" />
								</i>
							</el-input>
						</el-form-item>
						<el-form-item prop="passwordc" v-if="loginStatus == 3">
							<el-input v-model="ruleForm.passwordc" placeholder="请再出输入新密码" show-password>
								<i slot="prefix" style="display: flex; align-items: center; height: 38px">
									<img class="header-icon" src="@/assets/img/mima.svg" alt="" />
								</i>
							</el-input>
						</el-form-item>
						<div class="xyBox" v-if="loginStatus == 0 || loginStatus == 1">
							<div class="jzBtn">
								<el-checkbox-group v-model="jz" v-if="loginStatus == 0">
									<el-checkbox label="记住我" labelStyle="font-size:12px"></el-checkbox>
								</el-checkbox-group>
							</div>
							<div class="dxBtn supHove3" @click="dxFn">
								{{ loginStatus == 0 ? '短信验证码登录' : '密码登录' }}
							</div>
						</div>
						<el-form-item v-if="loginStatus != 2">
							<el-button type="primary" style="background: #1d7b3a; width: 100%" @click="onSubmit" v-preventReclick>
								{{ loginStatus == 3 ? '确认修改' : '登录' }}
							</el-button>
						</el-form-item>
					</el-form>
					<div class="ewImg" v-if="loginStatus == 2">
						<img :src="$erwUrl + ewData.base64Data" alt="" />
						<div class="mcBox" v-if="status != 1">
							<p v-if="status == 2">
								二维码已失效
								<br />
								请
								<span>重新获取</span>
							</p>
							<p v-if="status == 3">
								二维码已超时
								<br />
								请
								<span>重新获取</span>
							</p>
						</div>
					</div>
					<div class="formFot" v-if="loginStatus == 0 || loginStatus == 1 || loginStatus == 2">
						<div class="wjBtn supHove3" v-if="loginStatus != 2" @click="fhdlFn(3)">忘记密码？</div>
						<div class="wjBtn" v-if="loginStatus == 2">
							<span @click="fhdlFn(3)" class="supHove3">忘记密码？</span>
							<span @click="zcFn" class="supHove3">注册账户</span>
						</div>
						<div class="qtTip">其它方式登录</div>
						<div class="wxBtn" v-if="loginStatus != 2" @click="fhdlFn(2)">
							<img src="@/assets/img/weix.svg" class="supHove2" alt="" />
						</div>
						<div class="qtBtn" v-if="loginStatus == 2">
							<div class="qtLeft supHove3" @click="fhdlFn(0)">
								<img src="@/assets/img/mimaT.png" alt="" />
								密码登录
							</div>
							<div class="qtRight supHove3" @click="fhdlFn(1)">
								<img src="@/assets/img/yzmT.png" alt="" />
								验证码登录
							</div>
						</div>
					</div>
					<div class="formFot" v-if="loginStatus == 3">
						<div class="wjBtn supHove3" @click="fhdlFn(0)">返回登录</div>
					</div>
				</div>
				<div class="xyP">
					<el-checkbox v-model="xyFlag" style="margin-right: 6px; margin-top: -1px"></el-checkbox>
					阅读并同意
					<span class="supHove3" @click="xyBtn">《用户协议》</span>
					和
					<span @click="ysBtn" class="supHove3">《隐私政策》</span>
				</div>
			</div>
		</div>
		<loginFoot />
	</div>
</template>

<script>
import loginFoot from '@/components/foot/loginFoot';
import brieHeader from '@/components/hearder/brieHeader';
import { mapState, mapMutations } from 'vuex';

export default {
	name: 'LoginView',
	data() {
		return {
			ruleForm: {
				phone: '',
				smsCode: '',
				code: '',
				pasw: '',
				passwordc: '',
				password: '',
				uuid: ''
			},
			status: 1,
			jz: false,
			yzImg: '',
			ewData: {},
			loginStatus: 0, // 0密码 1验证码 2微信扫码 3忘记密码
			setInFn: '',
			nums: 60,
			setT: '',
			yymStatus: 0, // 0未获取 1获取中 2重新获取
			xyFlag: false,
			rules: {
				phone: [
					{ required: true, message: '请输入手机号码', trigger: 'blur' },
					{ pattern: /^1[1-9]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
				],
				pasw: [{ required: true, message: '请输入密码', trigger: 'blur' }],
				password: [{ required: true, validator: this.validatePass, trigger: 'blur' }],
				passwordc: [{ required: true, validator: this.validatePass2, trigger: 'blur' }],
				code: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
				smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
			}
		};
	},
	watch: {
		loginStatus: {
			handler: function (newValue) {
				if (newValue == 2) {
					this.hqErwi();
				} else {
					clearInterval(this.setT);
				}
				if (newValue == 0) {
					if (this.remepasw.zh) {
						this.ruleForm.phone = this.remepasw.zh;
						this.ruleForm.pasw = this.remepasw.mim;
						this.ruleForm.smsCode = '';
					}
				} else {
					this.ruleForm.phone = '';
					this.ruleForm.pasw = '';
					this.ruleForm.smsCode = '';
				}
			},
			immediate: true // 这会导致在wacth被创建时立即执行handler
		}
	},
	components: {
		brieHeader,
		loginFoot
	},
	computed: {
		...mapState(['remepasw', 'tabFlag'])
	},
	methods: {
		...mapMutations(['remeFn']),
		goAfterLogin() {
			if (this.tabFlag == 2) {
				this.$router.push({
					path: 'taotiziyuan'
				});
			} else {
				this.$router.push({
					path: 'home'
				});
			}
		},
		xyBtn() {
			this.$router.push({
				path: 'userAgreen',
				query: {
					type: 2
				}
			});
		},
		ysBtn() {
			this.$router.push({
				path: 'userAgreen',
				query: {
					type: 3
				}
			});
		},
		fhdlFn(type) {
			if (type == 2) {
				this.loginStatus = type;
			} else {
				this.loginStatus = type;
				this.init();
				this.clearFn();
			}
		},
		hqErwi() {
			let set = this.$loading(this.$pre);
			this.$http.post('api/app/login/getWxQrCode').then((res) => {
				set.close();
				if (res.code == 200) {
					console.log(res, 9999);
					this.status = 1;
					this.ewData = res.data;
					this.setT = setInterval((item) => {
						this.$http
							.post('api/app/login/getLoginByQrCode', {
								mockExam: this.tabFlag == 2 ? true : false,
								scene: this.ewData.uuid
							})
							.then((res) => {
								if (res.code == 200) {
									if (res.data.status == -1) {
										this.status = 2;
										clearInterval(this.setT);
									} else {
										if (res.data.status == 1) {
											clearInterval(this.setT);
											localStorage.setItem('token', res.data.user.token);
											localStorage.setItem('loginToModule', this.tabFlag == 2 ? '2' : '1');
											this.$store.commit('setInfoData', res.data.user);
											this.$message({
												message: '登录成功',
												type: 'success'
											});
											this.goAfterLogin();
										}
									}
									console.log(res);
								}
							});
					}, 2000);
				}
			});
		},
		init() {
			this.$http.get('api/captchaImage').then((res) => {
				this.ruleForm.uuid = res.uuid;
				// 处理响应数据
				this.yzImg = res.img;
			});
		},
		onSubmit() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					if (!this.xyFlag && this.loginStatus != 3) {
						this.$message({
							showClose: true,
							message: '请勾选用户协议',
							type: 'error'
						});
						return;
					}
					let set = this.$loading(this.$pre);
					if (this.loginStatus == 0) {
						// 密码登录
						console.log(this.ruleForm);
						let { pasw, password, ...datas } = this.ruleForm;
						this.$http
							.post('api/app/login/login', {
								mockExam: this.tabFlag == 2 ? true : false,
								password: pasw,
								...datas
							})
							.then((res) => {
								set.close();
								if (res.code == 200) {
									if (this.jz) {
										this.remeFn({
											zh: this.ruleForm.phone,
											mim: this.ruleForm.pasw
										});
									} else {
										this.remeFn({
											zh: '',
											mim: ''
										});
									}
									localStorage.setItem('token', res.data.token);
									localStorage.setItem('loginToModule', this.tabFlag == 2 ? '2' : '1');
									this.$store.commit('setInfoData', res.data);
									this.$message({
										message: '登录成功',
										type: 'success'
									});
									this.goAfterLogin();
								}
							});
					} else if (this.loginStatus == 1) {
						// 验证码登录
						console.log(this.ruleForm);
						this.$http
							.post('api/app/login/loginByCode', {
								mockExam: this.tabFlag == 2 ? true : false,
								...this.ruleForm
							})
							.then((res) => {
								set.close();
								if (res.code == 200) {
									this.yymStatus = 0;
									this.nums = 60;
									localStorage.setItem('token', res.data.token);
									localStorage.setItem('loginToModule', this.tabFlag == 2 ? '2' : '1');
									this.$store.commit('setInfoData', res.data);
									this.$message({
										message: '登录成功',
										type: 'success'
									});
									this.goAfterLogin();
								}
							});
					} else if (this.loginStatus == 3) {
						// 忘记密码
						console.log(this.ruleForm);
						this.$http
							.post('api/app/login/forgetPassword', {
								...this.ruleForm
							})
							.then((res) => {
								set.close();
								if (res.code == 200) {
									this.$refs.ruleForm.resetFields();
									this.yymStatus = 0;
									this.nums = 60;
									clearInterval(this.setInFn);
									this.$message({
										message: '修改成功',
										type: 'success'
									});
								}
							});
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		zcFn() {
			this.$router.push({
				path: './rega'
			});
		},
		dxFn() {
			this.loginStatus = this.loginStatus == 0 ? 1 : 0;
			this.init();
			this.clearFn();
		},
		hqBtn() {
			if (!/^1[1-9]\d{9}$/.test(this.ruleForm.phone)) {
				this.$message.error('请输入正确的手机号');
				return;
			}
			if (!this.ruleForm.code) {
				this.$message.error('请输入图形验证码');
				return;
			}
			this.$http
				.post('api/app/login/sendCode', {
					phone: this.ruleForm.phone,
					code: this.ruleForm.code,
					uuid: this.ruleForm.uuid
				})
				.then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '发送成功',
							type: 'success'
						});
						this.yymStatus = 1;
						this.setInFn = setInterval(() => {
							if (this.nums == 0) {
								this.yymStatus = 2;
								this.nums = 60;
								clearInterval(this.setInFn);
								return;
							}
							this.nums--;
						}, 1000);
					}
				});
		},
		clearFn() {
			this.$refs.ruleForm.clearValidate();
			this.$refs.ruleForm.resetFields();
		},
		validatePass(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.ruleForm.passwordc !== '') {
					this.$refs.ruleForm.validateField('passwordc');
				}
				callback();
			}
		},
		validatePass2(rule, value, callback) {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.setInFn);
		clearInterval(this.setT);
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.logPage {
	width: 1200px;
	margin: 74px auto 50px;
	height: 490px;
	box-shadow: 0 10px 32px 0 rgba(0, 0, 0, 0.09);
	display: flex;
	.logLeft {
		flex: 1;
		overflow: hidden;
		img {
			object-fit: cover;
			height: 100%;
		}
	}
	.logRig {
		flex: 1;
		box-sizing: border-box;
		background: #fff;
		border-radius: 0px 6px 6px 0px;
		justify-content: center;
		align-items: center;
		display: flex;
		padding-top: 43px;
		position: relative;
		padding-bottom: 41px;
		.xyP {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 41px;
			background: #f8f8fb;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 0px 0px 6px 0px;
			cursor: pointer;
			font-size: 12px;
			color: #8d92a5;
			span {
				color: #000000;
			}
		}
		.logBox {
			width: 292px;

			.logTip {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 16px;
				.logTipTit {
					font-size: 22px;
					font-weight: bold;
				}
				p {
					font-size: 12px;
					color: #000;
					span {
						cursor: pointer;
						color: #1d7b3a;
					}
				}
			}
			.logTipwj {
				justify-content: center;
			}
			.demoRuleForm {
				::v-deep .el-form-item__content {
					margin: 0 !important;
				}
				.logTx {
					display: flex;
					height: 50px;
					margin-bottom: 8px;
					.twBtn {
						width: 64px;
						height: 40px;
						margin-left: 10px;
						cursor: pointer;
						img {
							width: 64px;
							height: 40px;
						}
					}
				}
			}
			.xyBox {
				display: flex;
				justify-content: space-between;
				height: 40px;
				font-size: 12px;
				align-items: center;
				.dxBtn {
					color: #1d7b3a;
					cursor: pointer;
				}
			}
		}
		.ewImg {
			width: 180px;
			height: 180px;
			text-align: center;
			position: relative;
			margin: 0 auto 25px;
			img {
				width: 100%;
				height: 100%;
			}
			.mcBox {
				position: absolute;
				width: 100%;
				height: 100%;
				left: 0;
				top: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				background: rgba(0, 0, 0, 0.6);
				color: #fff;
				font-size: 14px;
				span {
					color: #fa4a1b;
					cursor: pointer;
				}
				p {
					line-height: 1.7;
				}
			}
		}
		.qtBtn {
			display: flex;
			justify-content: center;
			div {
				display: flex;
				align-items: center;
				margin-right: 81px;
				color: #1d7b3a;
				font-size: 12px;
				cursor: pointer;
				&:last-of-type {
					margin-right: 0;
				}
				img {
					width: 23px;
					height: 23px;
					margin-right: 2px;
				}
			}
		}
		.formFot {
			margin-top: -6px;
			.wjBtn {
				margin: 8px 0 14px;
				font-size: 12px;
				cursor: pointer;
				display: flex;
				justify-content: center;
				color: #1d7b3a;
				span {
					margin-right: 72px;
					&:last-of-type {
						margin-right: 0;
					}
				}
			}
			.qtTip {
				color: #8d92a5;
				font-size: 12px;
				text-align: center;
				position: relative;
				margin-bottom: 12px;
				&::before {
					content: '';
					position: absolute;
					width: 91px;
					height: 1px;
					background: #ececec;
					left: 0;
					top: 50%;
					transform: translateY(-1px);
				}
				&::after {
					content: '';
					position: absolute;
					width: 91px;
					height: 1px;
					background: #ececec;
					right: 0;
					top: 50%;
					transform: translateY(-1px);
				}
			}
			.wxBtn {
				text-align: center;
				margin-bottom: 6px;
				img {
					width: 36px;
					height: 36px;
					cursor: pointer;
				}
			}
		}
	}
}
::v-deep .el-form-item {
	margin-bottom: 18px;
}
.yymBox {
	font-size: 12px;
	span {
		color: #1d7b3a;
	}
	.hqyym {
		cursor: pointer;
	}
}
</style>
